import {lazy} from "react";

export const ActivateKit = lazy(() => import("./ActivateKit/ActivateKit"));
export const ActiveHealthPlan = lazy(() => import("./ActiveHealthPlan/ActiveHealthPlan"));
export const ActiveKit = lazy(() => import("./ActiveKit/ActiveKit"));
export const BespokeTest = lazy(() => import("./BespokeTest/BespokeTest"));
export const BookPhlebotomyAppointment = lazy(() => import("./BookPhlebotomyAppointment/BookPhlebotomyAppointment"));
export const Clinic = lazy(() => import("./Clinic/Clinic"));
export const ClinicFinderContainer = lazy(() => import("./ClinicFinder/ClinicFinderContainer"));
export const Dashboard = lazy(() => import("./Dashboard/Dashboard"));
export const Explore = lazy(() => import("./Explore/Explore"));
export const FemaleQuestions = lazy(() => import("./FemaleQuestions/FemaleQuestions.jsx"));
export const HealthPlans = lazy(() => import("./HealthPlans/HealthPlans.jsx"));
export const HealthScore = lazy(() => import("./HealthScore/HealthScore.jsx"));
export const HealthScoreDetails = lazy(() => import("./HealthScoreDetails/HealthScoreDetails.jsx"));
export const Learn = lazy(() => import("./Learn/Learn.jsx"));
export const Post = lazy(() => import("./Learn/Post/Post.jsx"));
export const LoadingData = lazy(() => import("./LoadingData/LoadingData.jsx"));
export const Page404 = lazy(() => import("./Page404/Page404.jsx"));
export const Plans = lazy(() => import("./Plans/Plans.jsx"));
export const Redirect = lazy(() => import("./Redirect/Redirect.jsx"));
export const ResetPassword = lazy(() => import("./ResetPassword/ResetPassword.jsx"));
export const Results = lazy(() => import("./Results/Results.jsx"));
export const Shop = lazy(() => import("./Shop/Shop.jsx"));
export const SignIn = lazy(() => import("./SignIn/SignIn.jsx"));
export const Signup = lazy(() => import("./Signup/Signup.jsx"));
export const YourResult = lazy(() => import("./Results/YourResult/YourResult.jsx"));
export const PinScreen = lazy(() => import("./PinScreen/PinScreen.jsx"));

export const ActivateKitNav = lazy(() => import("./MyAccount/ActivateKitNav/ActivateKitNav"));
export const ChangePassword = lazy(() => import("./MyAccount/ChangePassword/ChangePassword"));
export const Credit = lazy(() => import("./MyAccount/Credit/Credit"));
export const DeleteAccount = lazy(() => import("./MyAccount/DeleteAccount/DeleteAccount"));
export const HealthProfile = lazy(() => import("./MyAccount/HealthProfile/HealthProfile"));
export const Help = lazy(() => import("./MyAccount/Help/Help"));
export const ManageHealthCategories = lazy(() => import("./MyAccount/ManageHealthCategories/ManageHealthCategories"));
export const ManagePin = lazy(() => import("./MyAccount/ManagePin/ManagePin"));
export const OrderHistory = lazy(() => import("./MyAccount/OrderHistory/OrderHistory"));
export const PrivacyPolicy = lazy(() => import("./MyAccount/PrivacyPolicy/PrivacyPolicy"));
export const RateApp = lazy(() => import("./MyAccount/RateApp/RateApp"));
export const ReferAFriend = lazy(() => import("./MyAccount/ReferAFriend/ReferAFriend"));
export const Subscriptions = lazy(() => import("./MyAccount/Subscriptions/Subscriptions"));
export const TermsAndConditions = lazy(() => import("./MyAccount/TermsAndConditions/TermsAndConditions"));
export const WhatsNew = lazy(() => import("./MyAccount/WhatsNew/WhatsNew"));
export const ThirdPartyAccess = lazy(() => import("./MyAccount/ThirdPartyAccess/ThirdPartyAccess"));

// export {PinScreen} from "./PinScreen/PinScreen";
// export * as Learn from "./Learn";
// export * as MyAccount from "./MyAccount";
